import { AlbaranReadingDtoProps } from "./DTOs/AlbaranReadingDto"
import { AlbaranReadingFiltersDtoProps } from "./DTOs/AlbaranReadingFiltersDto"
import { AlbaranReadingSimpleDtoProps } from "./DTOs/AlbaranReadingSimpleDto"
import { DocumentoComercialAsociadoReadingDtoProps } from "./DTOs/DocumentoComercialAsociadoReadingDto"
import { FicheroReadingDtoProps } from "./DTOs/FicheroReadingDto"
import { ValidacionDocumentoReadingDtoProps } from "./DTOs/ValidacionDocumentoReadingDto"

export const albaranByFilterAdapter = (
  albaran: AlbaranReadingFiltersDtoProps
): AlbaranReadingFiltersDtoProps => {
  return {
    divisa: albaran.divisa,
    estadoRevisionActual: albaran.estadoRevisionActual,
    fechaEmision: albaran.fechaEmision,
    id: albaran.id,
    importe: albaran.importe,
    motivo: albaran.motivo,
    nifLibrado: albaran.nifLibrado,
    nifLibrador: albaran.nifLibrador,
    numero: albaran.numero,
    numeroFicherosAdjuntos: albaran.numeroFicherosAdjuntos,
    paisLibrado: albaran.paisLibrado,
    paisLibrador: albaran.paisLibrador,
    razonSocialLibrado: albaran.razonSocialLibrado,
    razonSocialLibrador: albaran.razonSocialLibrador,
    serie: albaran.serie,
    tipoDocumento: albaran.tipoDocumento,
  }
}

export const albaranByIdSimple = (
  albaran: AlbaranReadingSimpleDtoProps
): AlbaranReadingSimpleDtoProps => {
  return {
    id: albaran.id,
    divisa: albaran.divisa,
    empresa: albaran.empresa,
    estadoRevisionActual: albaran.estadoRevisionActual,
    fechaEmision: albaran.fechaEmision,
    fechaVencimiento: albaran.fechaVencimiento,
    importe: albaran.importe,
    motivo: albaran.motivo,
    serieNumero: albaran.serieNumero,
    tipoDocumento: albaran.tipoDocumento,
  }
}

export const albranDocAsociadosAdapter = (
  doc: DocumentoComercialAsociadoReadingDtoProps
): DocumentoComercialAsociadoReadingDtoProps => ({
  id: doc?.id,
  numero: doc?.numero,
  serie: doc?.serie,
  tipoDocumento: doc?.tipoDocumento,
})

export const albaranFicherosAdjuntosAdapter = (
  archivo: FicheroReadingDtoProps
): FicheroReadingDtoProps => ({
  id: archivo.id,
  esDocumentoImportado: archivo.esDocumentoImportado,
  extension: archivo.extension,
  mediaType: archivo.mediaType,
  nombre: archivo.nombre,
  ruta: archivo.ruta,
  tamañoEnBytes: archivo.tamañoEnBytes,
  tipo: archivo.tipo,
})

export const albaranById = (
  albaran: AlbaranReadingDtoProps
): AlbaranReadingDtoProps => {
  return {
    id: albaran.id,
    estadoRevisionActual: albaran.estadoRevisionActual,
    tipoDocumento: albaran.tipoDocumento,
    configuracion: albaran.configuracion,
    articuloDocumentos: albaran.articuloDocumentos,
    cliente: albaran.cliente,
    descuento: albaran.descuento,
    diasPago: albaran.diasPago,
    divisa: albaran.divisa,
    documentosAjustesPorDefecto: albaran.documentosAjustesPorDefecto,
    documentosComercialesAsociados: albaran.documentosComercialesAsociados,
    fechaEmision: albaran.fechaEmision,
    fechaOperacion: albaran.fechaOperacion,
    formaPago: albaran.formaPago,
    importe: albaran.importe,
    impuestoRetenido: albaran.impuestoRetenido,
    libradoId: albaran.libradoId,
    libradorId: albaran.libradorId,
    logo: albaran.logo,
    numero: albaran.numero,
    numeroAdjuntos: albaran.numeroAdjuntos,
    observaciones: albaran.observaciones,
    origen: albaran.origen,
    serie: albaran.serie,
    tarifaImpuesto: albaran.tarifaImpuesto,
    tipoDocumentoComercial: albaran.tipoDocumentoComercial,
    totalRetenido: albaran.totalRetenido,
    usuario: albaran.usuario,
    embalajes: albaran.embalajes,
    fechaEntrega: albaran.fechaEntrega,
    lugarEntrega: albaran.lugarEntrega,
  }
}

export const albaranDocumentoPendienteValidacionAdapter = (
  documento: ValidacionDocumentoReadingDtoProps
): ValidacionDocumentoReadingDtoProps => ({
  id: documento.id,
  autovalidacion: documento.autovalidacion,
  etapas: documento.etapas,
  rango: documento.rango,
  tipoDocumento: documento.tipoDocumento,
  todosLosRangos: documento.todosLosRangos,
})
